import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'dum-politica-cookies',
  templateUrl: './politica-cookies.component.html',
  styleUrls: ['./politica-cookies.component.scss']
})
export class PoliticaCookiesComponent implements OnInit {
  contents: any[];
  constructor(
    private translateService: TranslateService
  ) { 
    this.contents = [
      {
        titulo: this.translateService.instant('POLITICA.COOKIES.QUE.ES.UNA.COOKIE.TITULO'),
        cuerpo: this.translateService.instant('POLITICA.COOKIES.QUE.ES.UNA.COOKIE.CUERPO')
      },
      {
        titulo: this.translateService.instant('POLITICA.COOKIES.TIPOS.COOKIES.UTILIZADAS.TITULO'),
        cuerpo: this.translateService.instant('POLITICA.COOKIES.TIPOS.COOKIES.UTILIZADAS.CUERPO')
      },
      {
        titulo: this.translateService.instant('POLITICA.COOKIES.CONSETIMIENTO.CONFIGURACION.COOKIES.TITULO'),
        cuerpo: this.translateService.instant('POLITICA.COOKIES.CONSETIMIENTO.CONFIGURACION.COOKIES.CUERPO')
      },
      {
        titulo: this.translateService.instant('POLITICA.COOKIES.DESACTIVACION.ELIMINACION.COOKIE.TITULO'),
        cuerpo: this.translateService.instant('POLITICA.COOKIES.DESACTIVACION.ELIMINACION.COOKIE.CUERPO')
      },
      {
        titulo: this.translateService.instant('POLITICA.COOKIES.MAS.INFORMACION.TITULO'),
        cuerpo: this.translateService.instant('POLITICA.COOKIES.MAS.INFORMACION.CUERPO')
      }
    ]
  }

  ngOnInit(): void {
  }

}
